import { render } from "./ModelCategoryEdit.vue?vue&type=template&id=632e3af5"
import script from "./ModelCategoryEdit.vue?vue&type=script&lang=js"
export * from "./ModelCategoryEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__